import dispatcher from '../dispatcher';

var _copyElement = function(el, data) {
	var fake = document.createElement('div');
	var styles = getComputedStyle(el);
	var offset, t, l;

	if (this._fake) {
		this.removeChild(this._fake);
		this._fake = null;
	}

	fake.innerHTML = el.innerHTML;

	offset = el.getBoundingClientRect();
	t = offset.top;
	l = offset.left;

	fake.style.position = 'fixed';
	fake.style.left = l + 'px';
	fake.style.top = t + 'px';
	fake.classList.add('fake');

	if (data.class) {
		fake.classList.add(data.class);
	}

	this.appendChild(fake);

	this._fake = fake;

	fake.addEventListener('mouseleave', function(e) {
		dispatcher.dispatch({
			type: 'popup:close-all'
		});
	});
	fake.addEventListener('click', function(e) {
		el.click();
	});

	// return fake;
}

var _handleDispatcher = function(e) {
	if (e.type === 'map:set-fake') {
		this.copyElement(e.element, {
			class: 'map-fake'
		});
	}
	if (e.type === 'map:remove-fake') {
		if (this._fake) {
			this.removeChild(this._fake);
			this._fake = null;
		}
	}
}

var elementProto = Object.create(HTMLElement.prototype);

elementProto.createdCallback = function() {
	this.copyElement = _copyElement.bind(this);
	this.handleDispatcher = _handleDispatcher.bind(this);
}
elementProto.attachedCallback = function() {
	dispatcher.subscribe(this.handleDispatcher);
}
elementProto.detachedCallback = function() {
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('map-overlay', {
	prototype: elementProto
});